import {PAYMENT_POLICY, CONFIRMATION_POLICY, CANCELLATION_POLICY} from "./enums";

/**
 * cancellation policy: not_refundable, totally_refundable, time_restricted_refundable, none
 * confirmation policy: deposit, pre_paid, credit_card_guarantee, none
 * payment policy: online, host_customized
 */
export const bookingConditions = [
    // payment: policy hostCustomized, confirmation policy: deposit, cancellation policy: any
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.deposit,
        cancellationPolicy: CANCELLATION_POLICY.timeRestrictedRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.deposit,
        cancellationPolicy: CANCELLATION_POLICY.notRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.deposit,
        cancellationPolicy: CANCELLATION_POLICY.totallyRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.deposit,
        cancellationPolicy: CANCELLATION_POLICY.none,
    },
    // payment: policy hostCustomized, confirmation policy: prepaid, cancellation policy: any
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.prePaid,
        cancellationPolicy: CANCELLATION_POLICY.timeRestrictedRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.prePaid,
        cancellationPolicy: CANCELLATION_POLICY.notRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.prePaid,
        cancellationPolicy: CANCELLATION_POLICY.totallyRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.prePaid,
        cancellationPolicy: CANCELLATION_POLICY.none,
    },
    // payment: policy hostCustomized, confirmation policy: none, cancellation policy: any
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.none,
        cancellationPolicy: CANCELLATION_POLICY.timeRestrictedRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.none,
        cancellationPolicy: CANCELLATION_POLICY.notRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.none,
        cancellationPolicy: CANCELLATION_POLICY.totallyRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.hostCustomized,
        confirmationPolicy: CONFIRMATION_POLICY.none,
        cancellationPolicy: CANCELLATION_POLICY.none,
    },
    // payment policy: online
    {
        paymentPolicy: PAYMENT_POLICY.online,
        confirmationPolicy: CONFIRMATION_POLICY.deposit,
        cancellationPolicy: CANCELLATION_POLICY.timeRestrictedRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.online,
        confirmationPolicy: CONFIRMATION_POLICY.deposit,
        cancellationPolicy: CANCELLATION_POLICY.notRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.online,
        confirmationPolicy: CONFIRMATION_POLICY.prePaid,
        cancellationPolicy: CANCELLATION_POLICY.notRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.online,
        confirmationPolicy: CONFIRMATION_POLICY.creditCardGuarantee,
        cancellationPolicy: CANCELLATION_POLICY.totallyRefundable,
    },
    {
        paymentPolicy: PAYMENT_POLICY.online,
        confirmationPolicy: CONFIRMATION_POLICY.creditCardGuarantee,
        cancellationPolicy: CANCELLATION_POLICY.timeRestrictedRefundable,
    }
]